<template>
<div>

    <draggable v-model="items" :options="{ animation: 350, handle: '.menu-icon'}" @end="delayedSave">
    <div v-for="(item,index) in items" class="list-item hoverable clickable" @click="toggleItem(item)" :key="index">

        <div style="display:flex">
            <div>
                <div class="truncate pr-2" >
                    <v-icon v-if="item.status == 'NA'" class="green--text">highlight_off</v-icon>
                    <v-icon v-else :class="{'green--text': item.status == 'C', 'grey--text': item.status == 'NA', 'grey--text text--lighten-2': item.status == 'O'}">check_circle_outline</v-icon>
                </div>
            </div>
            
            <div style="flex-grow:1;padding-top:2px;">
                <span v-if="isCapitalised(item.text)" style="margin-top:12px;background-color:#ddd;border-radius:5px;font-weight:bold;font-size:0.9em;padding:5px 8px">{{item.text}}</span>
                <span v-else style="margin-top:12px">{{item.text}}</span>
            </div>
            <div @click.prevent.stop >
                <v-menu bottom left :nudge-width="200">
                        <template v-slot:activator="{ on }">
                        <v-icon class="menu-icon" v-on="on">keyboard_arrow_down</v-icon>
                        </template>
                    <v-list>
                        <v-list-item @click="showAddItem">
                            <v-list-item-title>Add Item</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteItem(item)">
                            <v-list-item-title>Delete Item</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    
                </v-menu>
            </div>
        </div>

    </div>
    </draggable>
    <div v-if="!items.length && !editing" class="list-item hoverable clickable" @click="showAddItem">
        <v-icon color="grey lighten-2" style="margin-right:5px">add_circle_outline</v-icon>
        Add Items
    </div>

    <template v-if="editing">
        <!-- <input :ref="'add_' + element.name" type="text" class="quick-input" /> -->
        <input v-model="newItem" ref="addTextbox" type="text" class="quick-input" placeholder="Add an item..." 
            @keyup.esc="cancelEditing" @blur="cancelEditing" @keypress.enter="addItem"  />
    </template> 

   
</div>
</template>

<script>
import Vue from 'vue'
// 
import draggable from 'vuedraggable'
import { differenceInSeconds } from 'date-fns/fp'

export default {
    data() {
        return {
            editing: false,
            newItem: '',
            items: this.list || [],
            lastChange: null,
            columns: 2,
        }
    },
    
    props: {
        list: Array,
        passBack: Object,
    },

    components: {
        draggable,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        isCapitalised(str) {
            return (str === str.toUpperCase())
        },

        showAddItem() {
            this.editing = true
            Vue.nextTick( () => {
                this.$refs.addTextbox.focus()
            })
        },

        addItem() {
            if(!this.newItem) {
                this.editing = false
                return
            }
                
            this.items.push({
                text: this.newItem,
                status: 'O'
            })
            this.newItem = ''
            this.delayedSave()
        },

        deleteItem(item) {
            let idx = this.items.indexOf(item)
            this.items.splice(idx, 1)
            this.delayedSave()
        },

        cancelEditing() {
            this.editing = false
            this.newItem = ''
        },

        toggleItem(item) {
            if(item.status == "C")
                item.status = 'NA'
            else if(item.status == 'NA')
                item.status = "O"
            else
                item.status = "C"

            if(this.isCapitalised(item.text)) 
                this.cascadeStatus(item)   
            this.delayedSave()
        },

        cascadeStatus(item) {
            if(item.status == 'C')
                return

            let idx = this.list.findIndex(o => o.text == item.text)
            for(var n=idx + 1; n < this.list.length; n++) {
                if(this.isCapitalised(this.list[n].text))
                    break
                this.list[n].status = item.status
            }
        },


        delayedSave() {
            this.lastChange = new Date()
            setTimeout( () => {
                //let seconds = Moment().diff(this.lastChange, 'seconds')
                const seconds = differenceInSeconds(this.lastChange, new Date())
                
                if(seconds >= 3) {
                    let completedItems = this.items.filter(o => o.status != 'O')
                    let percent = parseInt(completedItems.length / (this.items.length || 0.1) * 100) // 0.1 to prevent NaN error
                    let result = Object.assign({checklist: this.items, percent}, this.passBack)
                    this.$emit('save', result)
                }
            }, 3100)
        }
    }
}
</script>

<style scoped>

.list-item{
    color:#777;padding:7px;
    font-size:1.1em
}

.menu-icon {
    color: #ccc;
}
.menu-icon:hover {
    color: #777;
}
   
</style>




// WEBPACK FOOTER //
// checklist.vue?cdf852e2